module.exports = __webpack_public_path__ + "static/media/Lato-Regular.27bd77b9.woff";